// extracted by css-extract-rspack-plugin
export default {"ResourceCard":"M7YXF"};